<template>
  <vxe-grid
    border
    show-overflow
    resizable
    ref="desiredSpaceTableRef"
    class="vxe-table-element"
    size="mini"
    align="center"
    :auto-resize="true"
    :data="data"
    :toolbar="{}"
    :valid-config="{ autoPos: true, message: 'inline' }"
    @select-change="handleSelectionChange"
    @select-all="handleSelectionChange"
    @edit-closed="closeEditTableHandler"
    :edit-config="disabled ? {} : { trigger: 'click', mode: 'row' }"
    height="300"
  >
    <template v-slot:buttons v-if="!disabled">
      <el-button @click="newRowHandler" size="small" type="primary" class="vxe-btn-primary"
        >新增</el-button
      >
      <el-button @click="deleteRowHandler" size="small" type="danger" class="vxe-btn-delete"
        >删除</el-button
      >
    </template>
    <vxe-table-column type="checkbox" width="50" fixed="left" v-if="!disabled"> </vxe-table-column>
    <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column>
    <vxe-table-column
      v-for="(item, index) in columns"
      :key="index"
      :type="item.type"
      :fixed="item.fixed"
      :field="item.field"
      :title="item.title"
      :width="item.width"
      :edit-render="item.editRender"
    >
      <template v-slot:edit="{ row }">
        <el-select
          v-if="item.field == 'spaceAreaName'"
          filterable
          value-key="id"
          placeholder="片区"
          clearable
          v-model="row[item.field]"
          @change="(value) => handleChange(row, item.field, value)"
        >
          <el-option
            v-for="(item, index) in treeData"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-else-if="item.field == 'spaceAssetName'"
          filterable
          value-key="id"
          placeholder="资产"
          clearable
          v-model="row[item.field]"
          @change="(value) => handleChange(row, item.field, value)"
        >
          <el-option
            v-for="(item, index) in getOptions(row, 'spaceAssetId')"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-else-if="item.field == 'spaceUnitName'"
          filterable
          value-key="id"
          placeholder="单元"
          clearable
          v-model="row[item.field]"
          @change="(value) => handleChange(row, item.field, value)"
        >
          <el-option
            v-for="(item, index) in getOptions(row, 'spaceUnitId')"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-else-if="item.field == 'spaceFloorName'"
          filterable
          value-key="id"
          placeholder="楼层"
          clearable
          v-model="row[item.field]"
          @change="(value) => handleChange(row, item.field, value)"
        >
          <el-option
            v-for="(item, index) in getOptions(row, 'spaceFloorId')"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-select
          v-else-if="item.field == 'spaceName'"
          filterable
          value-key="id"
          placeholder="房号"
          clearable
          v-model="row[item.field]"
          @change="(value) => handleChange(row, item.field, value)"
        >
          <el-option
            v-for="(item, index) in getOptions(row, 'spaceId')"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </template>
    </vxe-table-column>
  </vxe-grid>
</template>

<script>
  export default {
    name: 'DesiredSpaceTable',
    props: {
      tableData: {
        type: Array,
        default: () => [],
      },
      nicheCompanyNo: {
        type: String,
        default: () => '',
      },
      disabled: {
        type: Boolean,
        default: () => false,
      },
    },
    watch: {
      tableData: {
        handler(val) {
          if (val && val.length) {
            this.fullTableData(val);
          }
        },
        immediate: true,
        deep: true,
      },
      nicheCompanyNo: {
        handler(val) {
          if (val && val.length) {
            this.companyNo = val;
            console.log('table company changed', this.companyNo);
            this.getSpaceData();
          }
        },
        immediate: true,
        deep: true,
      },
    },
    mounted() {
      this.getSpaceData();
    },
    data() {
      return {
        tableTotal: 0,
        selectedList: [],
        data: [],
        companyNo: null,
        treeData: [],
        columns: [
          {
            field: 'spaceAreaName',
            title: '片区',
            width: '150',
            editRender: { name: 'spaceAreaName' },
          },
          {
            field: 'spaceAssetName',
            title: '资产',
            width: '150',
            editRender: { name: 'spaceAssetName' },
          },
          {
            field: 'spaceUnitName',
            title: '单元',
            width: '150',
            editRender: { name: 'spaceUnitName' },
          },
          {
            field: 'spaceFloorName',
            title: '楼层',
            width: '150',
            editRender: { name: 'spaceFloorName' },
          },
          {
            field: 'spaceName',
            title: '房号',
            width: '150',
            editRender: { name: 'spaceName' },
          },
        ],
      };
    },
    methods: {
      // 获取表格数据
      getTableData() {
        const $table = this.$refs.desiredSpaceTableRef;
        return $table.getTableData().fullData;
      },
      // 反填数据
      fullTableData(val) {
        if (val && val.length) {
          this.data = val;
        } else {
          this.data = [];
        }
      },
      // 新增行
      async newRowHandler() {
        this.clearSelection();
        const $table = this.$refs.desiredSpaceTableRef;
        const rowData = {};
        $table.setRadioRow(rowData);
        this.insertEvent(rowData, 0);
      },
      async insertEvent(rowData = {}, index = 0) {
        const $table = this.$refs.desiredSpaceTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (!errMap) {
          const { row: newRow } = await $table.insertAt(rowData, index);
          await $table.setActiveRow(newRow); // 设置当前行为活跃
          await $table.validate(newRow).catch((errMap) => errMap);
        }
      },
      deleteRowHandler() {
        if (this.selectedList.length < 1) {
          this.$message({
            showClose: true,
            message: this.$t('billDetail.message.noData'),
            type: 'error',
          });
          return;
        }
        this.$confirmAction()
          .then(() => {
            this.$refs.desiredSpaceTableRef.removeSelecteds();
            this.$emit('handleTableChange', 'desiredSpace', this.getTableData());
            this.$message({
              showClose: true,
              type: 'success',
              message: this.$t('billDetail.message.deleteSuccess'),
            });
          })
          .catch(() => {
            this.$message({
              showClose: true,
              type: 'info',
              message: this.$t('billDetail.message.cancelled'),
            });
          });
      },
      clearSelection() {
        this.$refs.desiredSpaceTableRef.clearCheckboxRow();
        this.selectedList = [];
      },
      clearLevel(level, row) {
        //5清空asset unit floor space
        //4清空 unit floor space
        //3清空 floor space
        //2清空 space
        if (level > 4) {
          if (row['spaceAssetName']) {
            row['spaceAssetName'] = null;
            row['spaceAssetId'] = null;
            console.log('asset clear');
          }
        }
        if (level > 3) {
          if (row['spaceUnitName']) {
            row['spaceUnitName'] = null;
            row['spaceUnitId'] = null;
            console.log('unit clear');
          }
        }
        if (level > 2) {
          if (row['spaceFloorName']) {
            row['spaceFloorName'] = null;
            row['spaceFloorId'] = null;
            console.log('floor clear');
          }
        }
        if (level > 1) {
          if (row['spaceName']) {
            row['spaceName'] = null;
            row['spaceId'] = null;
            console.log('space clear');
          }
        }
      },
      handleChange(row, field, value) {
        console.log('rowData', row, field, value);

        let areaItem = this.treeData?.find(
          (item) => item.id == (field == 'spaceAreaName' ? value : row['spaceAreaId'])
        );
        let assetItem = areaItem?.children?.find(
          (item) => item.id == (field == 'spaceAssetName' ? value : row['spaceAssetId'])
        );
        let unitItem = assetItem?.children?.find(
          (item) => item.id == (field == 'spaceUnitName' ? value : row['spaceUnitId'])
        );
        let floorItem = unitItem?.children?.find(
          (item) => item.id == (field == 'spaceFloorName' ? value : row['spaceFloorId'])
        );
        let spaceItem = floorItem?.children?.find(
          (item) => item.id == (field == 'spaceName' ? value : row['spaceId'])
        );

        if (field == 'spaceAreaName') {
          if (areaItem) {
            row['spaceAreaName'] = areaItem.name;
            row['spaceAreaId'] = areaItem.id;
            this.clearLevel(5, row);
          }
          console.log('areaItem', areaItem);
        } else if (field == 'spaceAssetName') {
          if (assetItem) {
            row['spaceAssetName'] = assetItem.name;
            row['spaceAssetId'] = assetItem.id;
            this.clearLevel(4, row);
          }
        } else if (field == 'spaceUnitName') {
          if (unitItem) {
            row['spaceUnitName'] = unitItem.name;
            row['spaceUnitId'] = unitItem.id;
            this.clearLevel(3, row);
          }
        } else if (field == 'spaceFloorName') {
          if (floorItem) {
            row['spaceFloorName'] = floorItem.name;
            row['spaceFloorId'] = floorItem.id;
            this.clearLevel(2, row);
          }
        } else if (field == 'spaceName') {
          if (spaceItem) {
            row['spaceName'] = spaceItem.name;
            row['spaceId'] = spaceItem.id;
          }
        }
        console.log('rowChanged', row);
      },

      _isLeafPoint(item) {
        if (!item || !item.children || item.children.length == 0) {
          return true;
        }
        return false;
      },
      getOptions(row, editRenderName) {
        let options = [];
        let areaItem = this.treeData?.find((item) => item.id == row['spaceAreaId']);
        let assetItem = areaItem?.children?.find((item) => item.id == row['spaceAssetId']);
        let unitItem = assetItem?.children?.find((item) => item.id == row['spaceUnitId']);
        let floorItem = unitItem?.children?.find((item) => item.id == row['spaceFloorId']);
        let spaceItem = floorItem?.children?.find((item) => item.id == row['spaceId']);

        let curData = this.getTableData();

        // let curAreaList = curData.map((item) => {
        //   return item.spaceAreaId;
        // });
        let curAssetList = curData.map((item) => {
          return Number(item.spaceAssetId);
        });
        let curUnitList = curData.map((item) => {
          return Number(item.spaceUnitId);
        });
        let curFloorList = curData.map((item) => {
          return Number(item.spaceFloorId);
        });
        let curSpaceList = curData.map((item) => {
          return Number(item.spaceId);
        });

        switch (editRenderName) {
          case 'spaceAssetId':
            if (areaItem) {
              let list = [];
              if (areaItem.children) {
                for (let item of Array.from(areaItem.children)) {
                  if (
                    this._isLeafPoint(item) &&
                    curAssetList.includes(Number(item?.id)) &&
                    item?.id != assetItem?.id
                  ) {
                    console.log('delete');
                  } else {
                    list.push(item);
                  }
                }
                options = list;
              }
            }
            break;
          case 'spaceUnitId':
            if (assetItem) {
              let list = [];
              if (assetItem.children) {
                for (let item of Array.from(assetItem.children)) {
                  if (
                    this._isLeafPoint(item) &&
                    curUnitList.includes(Number(item?.id)) &&
                    item?.id != unitItem?.id
                  ) {
                    console.log('delete');
                  } else {
                    list.push(item);
                  }
                }
              }

              options = list;
            }
            break;
          case 'spaceFloorId':
            if (unitItem) {
              let list = [];
              if (unitItem.children) {
                for (let item of Array.from(unitItem.children)) {
                  if (
                    this._isLeafPoint(item) &&
                    curFloorList.includes(Number(item?.id)) &&
                    item?.id != floorItem?.id
                  ) {
                    console.log('delete');
                  } else {
                    list.push(item);
                  }
                }
              }

              options = list;
            }
            break;
          case 'spaceId':
            if (floorItem) {
              let list = [];
              if (floorItem.children) {
                for (let item of Array.from(floorItem.children)) {
                  if (!curSpaceList.includes(Number(item?.id)) && item?.id != spaceItem?.id) {
                    list.push(item);
                  }
                }
              }
              options = list;
            }
            break;
          default:
            break;
        }
        return options;
      },
      async getSpaceData() {
        let companyCode = this.userInfo.companyCode;
        if (this.companyNo && this.companyNo.length) {
          companyCode = this.companyNo;
        }
        var { data } = await this.$axios.post('/property/space/tree', {
          spaceCompanyNo: companyCode,
          effectiveStatus: '02',
          // id: parentId.toString(),
        });
        console.log('spaceInfo', data);
        if (data.code == 0) {
          this.treeData = data.data;
        } else {
          this.$message.error(data.msg);
        }
      },
      handleSelectionChange({ selection }) {
        console.log(selection, '选择行');
        this.selectedList = selection;
      },
      async closeEditTableHandler() {
        const $table = this.$refs.desiredSpaceTableRef;
        const errMap = await $table.validate().catch((errMap) => errMap);
        if (errMap) {
          this.$message.error('请检查数据再提交');
        } else {
          // 派发事件
          this.$emit('handleTableChange', 'desiredSpace', this.getTableData());
          await $table.clearActived();
        }
      },
    },
  };
</script>
